import PropTypes from 'prop-types';
import React from 'react';
import dynamic from 'next/dynamic';

import Container from '../../layout/container/container';
import { StyledTeaserContainer } from './teaserContainer.style';

import Headline from '../../atoms/headline/headline';
import ArticleTeaser from '../../molecules/article-teaser/articleTeaser';
import EventTeaser from '../../molecules/event-teaser/eventTeaser';

const BasicTeaser = dynamic(() => import('../../molecules/basic-teaser/basicTeaser'));

const renderTeaser = (teaser, index, teaserLength) => ({
  // gomusEvent: (
  //   <EventTeaser
  //     {...teaser}
  //     id={null}
  //     key={`${teaser.slug}-${teaser.id ? teaser.id : index}`}
  //     size="s"
  //     className="teaserContainer__teaser"
  //   />
  // ),
  // gomusDate: (
  //   <EventTeaser
  //     {...teaser}
  //     id={null}
  //     key={`${teaser.slug}-${teaser.id ? teaser.id : index}`}
  //     size="s"
  //     className="teaserContainer__teaser"
  //   />
  // ),
  event: (
    <EventTeaser
      {...teaser}
      id={null}
      key={`${teaser.slug}-${teaser.id ? teaser.id : index}`}
      size="s"
      className="teaserContainer__teaser"
    />
  ),
  article: (
    <ArticleTeaser
      {...teaser}
      id={null}
      key={`${teaser.slug}-${teaser.id ? teaser.id : index}`}
      size={index === 0 && teaserLength === 3 ? 'm' : 's'}
      className="teaserContainer__teaser"
    />
  ),
  thinkingSpace: (
    <ArticleTeaser
      {...teaser}
      id={null}
      key={`${teaser.slug}-${teaser.id ? teaser.id : index}`}
      size={index === 0 && teaserLength === 3 ? 'm' : 's'}
      className="teaserContainer__teaser"
    />
  ),
  station: (
    <ArticleTeaser
      {...teaser}
      id={null}
      key={`${teaser.slug}-${teaser.id ? teaser.id : index}`}
      size={index === 0 && teaserLength === 3 ? 'm' : 's'}
      className="teaserContainer__teaser"
    />
  ),
  basicTeaser: (
    <BasicTeaser
      {...teaser}
      id={null}
      key={`${teaser.slug}-${teaser.id ? teaser.id : index}`}
      size={index === 0 && teaserLength === 3 ? 'm' : 's'}
      className="teaserContainer__teaser teaserContainer__teaser_basic"
      orientation={teaser.imageFormat || 'landscape'}
    />
  ),
  pressKit: (
    <BasicTeaser
      {...teaser}
      id={null}
      key={`${teaser.slug}-${teaser.id ? teaser.id : index}`}
      size="s"
      className="teaserContainer__teaser"
      orientation={teaser.imageFormat || 'landscape'}
    />
  ),
  staticPage: (
    <BasicTeaser
      {...teaser}
      id={null}
      key={`${teaser.slug}-${teaser.id ? teaser.id : index}`}
      size={index === 0 && teaserLength === 3 ? 'm' : 's'}
      className="teaserContainer__teaser"
      orientation={teaser.imageFormat || 'landscape'}
    />
  ),
  landingpageSimple: (
    <BasicTeaser
      {...teaser}
      id={null}
      key={`${teaser.slug}-${teaser.id ? teaser.id : index}`}
      size={index === 0 && teaserLength === 3 ? 'm' : 's'}
      className="teaserContainer__teaser"
      orientation={teaser.imageFormat || 'landscape'}
    />
  )
});

const TeaserContainer = ({ data, headline, topMargin = false, ...props }) => (
  <StyledTeaserContainer {...props} topMargin={topMargin} teaserLength={data.length}>
    {headline && <Headline>{headline}</Headline>}
    <Container className="teaserContainer__container">
      {data.map((teaser, index) => renderTeaser(teaser, index, data.length)[teaser.teaserType])}
    </Container>
  </StyledTeaserContainer>
);

TeaserContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  headline: PropTypes.string,
  topMargin: PropTypes.bool
};

export default TeaserContainer;
